import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    label: {marginBottom: 0},
    labelContainer: {display: "flex", alignItems: "center", minHeight: 55},
    requiredContainer: {marginRight: 5}
}));

export default useStyles;